module.exports = __webpack_public_path__ + "static/media/MIAB9801-180730-113_Small.3034a19c.jpg";